/* import __COLOCATED_TEMPLATE__ from './ios.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';

export const LANGUAGES = [
  {
    text: 'Swift',
    value: 'swift',
  },
  {
    text: 'Objective-C',
    value: 'obj-c',
  },
];

export default Component.extend({
  languages: LANGUAGES,

  selectedLanguage: 'swift',
});
